/* eslint-disable no-use-before-define */
import axios from 'services/axios.wrapper';
import config from 'services/config';

const { apiServer } = config;
const licenseUrl = `${apiServer}/ccp/v1/license`;

export default {
  getLicenses,
  getSingleLicense,
  postLicense,
  deleteLicense,
  putLicense
};

const mapLicense = license => ({
  EffectiveDate: license.EffectiveDate != null ? license.EffectiveDate.toLocaleDateString() : null,
  ExpirationDate: license.ExpirationDate != null ? license.ExpirationDate.toLocaleDateString() : null,
  LicenseNumber: license.LicenseNumber,
  DoesNotExpire: license.DoesNotExpire,
  RegionId: license.RegionId,
  LicenseTypeId: license.LicenseTypeId,
  LicenseUid: license.LicenseUid
});

function getLicenses() {
  const promise = axios.get(licenseUrl);
  promise.catch(error => console.error(error));
  return promise;
}

function getSingleLicense(id) {
  const promise = axios.get(`${licenseUrl}/${id}`);
  promise.catch(error => console.error(error));
  return promise;
}

function postLicense(license) {
  const newLicense = mapLicense(license);
  const promise = axios.post(licenseUrl, newLicense);
  promise.catch(error => console.error(error));
  return promise;
}

function deleteLicense(id) {
  const promise = axios.delete(`${licenseUrl}/${id}`);
  promise.catch(error => console.error(error));
  return promise;
}

function putLicense(license) {
  const newLicense = mapLicense(license);
  const promise = axios.put(licenseUrl, newLicense);
  promise.catch(error => console.error(error));
  return promise;
}
